/**
 * IDG Voice Meeting Overlay
 * 
 * Overlay wrapper for IDG meeting with voice fingerprinting
 */

import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import IDGVoiceMeeting from "@/components/IDGVoiceMeeting";
import { Users, Fingerprint } from "lucide-react";

export default function IDGVoiceMeetingOverlay({ isOpen, onClose }) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-[1200px] max-w-[95vw] bg-slate-900 border-slate-700 text-white overflow-y-auto">
        <SheetHeader>
          <SheetTitle className="text-white flex items-center gap-2">
            <Users className="w-5 h-5 text-teal-400" />
            IDG Meeting
            <span className="flex items-center gap-1 text-sm font-normal text-purple-400">
              <Fingerprint className="w-4 h-4" />
              Voice Fingerprinting
            </span>
          </SheetTitle>
          <SheetDescription className="text-slate-400">
            Record IDG meetings with automatic speaker identification and transcription
          </SheetDescription>
        </SheetHeader>
        
        <div className="mt-4">
          <IDGVoiceMeeting onClose={onClose} />
        </div>
      </SheetContent>
    </Sheet>
  );
}

export { IDGVoiceMeetingOverlay };
